import pluralize from 'pluralize';

// TODO - rework this
const pluralizeAndFormat = (string) => {
  if (string.length > 0) {
    const plural = pluralize(string);
    const stringArray = plural.split('');
    const lastCharacter = stringArray.splice(-1, 1)[0].toLowerCase();
    stringArray.push(lastCharacter);
    return stringArray.join('');
  }
  return string;
};

export const getAssessmentTerms = (assessmentTerm) => ({
  assessment: assessmentTerm,
  assessmentTermPlural: pluralizeAndFormat(assessmentTerm),
  assessmentTermSingular: assessmentTerm,
});

export default pluralizeAndFormat;
